import { PortfolioViewRouteParamKeys } from '@upright/ui/views/model-entity-views/portfolio-view/types';
import { ProductViewRouteParamKeys } from '@upright/ui/views/model-entity-views/product-view/types';
import { getModelEntityPathCommonOptionalParams } from '@upright/ui/views/model-entity-views/types';
import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { getRoutes } from '../route-utils';
import { RouteDatum } from '../types';

const CompanyView = lazy(async () => await import('@upright/ui/views/model-entity-views/company-view'));
const CompanyGroupView = lazy(async () => await import('@upright/ui/views/model-entity-views/company-group-view'));
const PortfolioView = lazy(async () => await import('@upright/ui/views/model-entity-views/portfolio-view'));
const DmaV2HomeView = lazy(async () => await import('@upright/ui/views/dma-v2-view'));
const DmaV2DashboardIndexView = lazy(async () => await import('@upright/ui/views/dma-v2-view/dashboard-index'));

const ProductView = lazy(async () => await import('@upright/ui/views/model-entity-views/product-view'));

export function getEntityViewRoutes() {
  return (
    <>
      <Route path="dashboard/*" element={<DmaV2DashboardIndexView />} />
      <Route path="company/:id/:name/dashboard/*" element={<DmaV2HomeView />} />
      <Route path="company/:id/*" element={<CompanyView />} />
      <Route path="company-group/:id/*" element={<CompanyGroupView />} />
      {legacyEntityViewRoutes}
    </>
  );
}

const legacyEntityViewRouteData: RouteDatum[] = [
  {
    path: `/product/:id`,
    optionalParams: [
      ...getModelEntityPathCommonOptionalParams(ProductViewRouteParamKeys),
      ProductViewRouteParamKeys.drilldownMode,
      ProductViewRouteParamKeys.selection,
    ],
    element: <ProductView />,
  },
  {
    path: `/portfolio/:id`,
    optionalParams: getModelEntityPathCommonOptionalParams(PortfolioViewRouteParamKeys),
    element: <PortfolioView />,
  },
];

const legacyEntityViewRoutes = getRoutes(legacyEntityViewRouteData);
